import { createAsyncThunk } from '@reduxjs/toolkit'
import apiClient from '../../../services/axois'
import { API_ROUTES } from '../../../utility/api.routes'
import { toast } from 'react-toastify'

export const getAllBanks = createAsyncThunk('inquirySource/getBanks', async () => {
  try {
    const url = '/banks'
    const response = await apiClient.get(url)
    return response?.data?.result
  } catch (error) {
    console.error('builder function error:', error)
    throw error
  }
})

export const createBank = createAsyncThunk('inquirySource/createBank', async ({ bankName, dispatch, setOpen }) => {
  try {
    const bankData = {
      bankName,
    }

    const url = '/bank'
    const response = await apiClient.post(url, bankData)

    if (response?.status) {
      setOpen(false)
      dispatch(getAllBanks())
      toast.success(response.data.message, {
        className: 'custom-toast-success',
        progressStyle: { background: '#ffffff' },
      })
    }
  } catch (error) {
    toast.error(error.response.data.message, {
      className: 'custom-toast-error',
      progressStyle: { background: '#C53C43' },
    })
    throw error
  }
})

export const editBank = createAsyncThunk('inquirySource/editBank', async (data, { dispatch }) => {
  try {
    const bankData = {
      bankName: data.value.bankName,
      bankStatus: data.value.status,
    }

    const url = `/bank/${data.value.bankId}`
    // const url = API_ROUTES.INQUIRY_SOURCE.PUT_INQUIRY_SOURCE(data.bankId)
    const response = await apiClient.put(url, bankData)

    
    if (response?.status) {
      data.setEditInventoryDrawer(false)
      dispatch(getAllBanks())
      toast.success(response.data.message, {
        className: 'custom-toast-success',
        progressStyle: { background: '#ffffff' },
      })
    }
  } catch (error) {
    toast.error(error.response.data.message, {
      className: 'custom-toast-error',
      progressStyle: { background: '#C53C43' },
    })
    throw error
  }
})

export const getDesignation = createAsyncThunk('inquirySource/getDesignation', async () => {
  try {
    const url = '/designation'
    const response = await apiClient.get(url)
    return response?.data?.result
  } catch (error) {
    console.error('builder function error:', error)
    throw error
  }
})

export const createDesignation = createAsyncThunk('inquirySource/designationBank', async ({ designationName, dispatch, setOpen }) => {
  try {
    const designationData = {
      designationName,
    }

    const url = '/designation'
    const response = await apiClient.post(url, designationData)

    
    if (response?.status) {
      setOpen(false)
      dispatch(getDesignation())
      toast.success(response.data.message, {
        className: 'custom-toast-success',
        progressStyle: { background: '#ffffff' },
      })
    }
  } catch (error) {
    toast.error(error.response.data.message, {
      className: 'custom-toast-error',
      progressStyle: { background: '#C53C43' },
    })
    throw error
  }
})

export const editDesignation = createAsyncThunk('inquirySource/editDesignation', async (data, { dispatch }) => {
  try {
    const designationData = {
      designationName: data.value.designationName,
      status: data.value.status,
    }

    const url = `/designation/${data.value.designationId}`
    const response = await apiClient.put(url, designationData)

    
    if (response?.status) {
      data.seteditDesignationDrawer(false)
      dispatch(getDesignation())
      toast.success(response.data.message, {
        className: 'custom-toast-success',
        progressStyle: { background: '#ffffff' },
      })
    }
  } catch (error) {
    toast.error(error.response.data.message, {
      className: 'custom-toast-error',
      progressStyle: { background: '#C53C43' },
    })
    throw error
  }
})
